module.exports = __webpack_public_path__ + "static/media/empty.cfb49f55.svg";